import React, { useState } from "react";
import { DatEntryModel, HsnTsnModel } from "../../api/hsntsnApi";
import { Form, Table } from "react-bootstrap";

interface DatHsnHsnProps {
  entries: DatEntryModel[];
  selectedEntries: HsnTsnModel[];
  selectionChanged: (hsn: string, tsn: string, selected: boolean) => void;
}

function DatHsnTsn({
  entries,
  selectedEntries,
  selectionChanged,
}: DatHsnHsnProps) {
  const [selectedDatEntry, setSelectedDatEntry] = useState<
    DatEntryModel | undefined
  >();

  const isSelected = (entry: DatEntryModel) => {
    return (
      selectedEntries.findIndex(
        (x) => x.hsn === entry.hsn && x.tsn === entry.tsn
      ) >= 0
    );
  };

  return (
    <>
      <Table hover={true}>
        <thead>
          <tr>
            <th>Include</th>
            <th>HSN</th>
            <th>TSN</th>
            <th>Make</th>
            <th>Main Type</th>
            <th>Sub Type</th>
          </tr>
        </thead>
        <tbody>
          {(entries.length ?? 0) === 0 ? (
            <tr>
              <td colSpan={6}>No DAT entries...</td>
            </tr>
          ) : (
            entries.map((x) => (
              <tr
                key={`${isSelected(x)}_${x.hsn}_${x.tsn}`}
                onClick={() => setSelectedDatEntry(x)}
                role="button"
                className={selectedDatEntry === x ? "table-active" : ""}
              >
                <td>
                  <Form.Check
                    defaultChecked={isSelected(x)}
                    onChange={(e) =>
                      selectionChanged(x.hsn!, x.tsn!, e.target.checked)
                    }
                  />
                </td>
                <td>{x.hsn}</td>
                <td>{x.tsn}</td>
                <td>{x.make}</td>
                <td>{x.mainType}</td>
                <td>{x.subType}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <hr />
      <Table>
        <thead>
          <tr>
            <th>Make</th>
            <th>Main</th>
            <th>Sub Type</th>
            <th>Engine</th>
            <th>Body Style</th>
            <th>Fuel Type</th>
            <th>Construction Date</th>
          </tr>
        </thead>
        <tbody>
          {!selectedDatEntry && (
            <tr>
              <td colSpan={7}>Select a DAT entry for details</td>
            </tr>
          )}

          {selectedDatEntry &&
            selectedDatEntry.details &&
            selectedDatEntry.details.map((x, index) => (
              <tr key={index}>
                <td>{x.make}</td>
                <td>{x.main}</td>
                <td>{x.subType}</td>
                <td>{x.engine}</td>
                <td>{x.bodyStyle}</td>
                <td>{x.fuelType}</td>
                <td>{x.constructionDate}</td>
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );
}

export default DatHsnTsn;
